module.exports = __webpack_public_path__ + "static/img/case_detail_02_2_h5.b224a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_2_h5.png
// module id = Z+V8
// module chunks = 34